import MagazinePage from '../magazine_page';
import categoryPageStateManager from '../category_page_state_manager';

export default function(store) {
  return {
    path: '/magazine',
    component: MagazinePage,
    strict: true,
    exact: true,
    loadData: categoryPageStateManager(store, 'magazine')
  };
}
